"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMultiColumn;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UIMultiColumn(props) {
  var children = props.children,
      className = props.className,
      flush = props.flush,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "flush"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classNames.default)('private-multicolumn', {
      'private-multicolumn--flush': flush
    }, className)
  }), children);
}

UIMultiColumn.displayName = 'UIMultiColumn';
UIMultiColumn.propTypes = {
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool.isRequired
};
UIMultiColumn.defaultProps = {
  flush: false
};
module.exports = exports.default;